(() => {
  'use strict';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));
  const roleNames = {client_owner:'Client Owner',client_manager:'Client Manager',client_employee:'Client Contributor'};
  const locked = new Set(['client.package_changes.approve','client.team.manage']);
  const labelStatus = {
    pending:'Awaiting Headquarters approval',approved:'Approved by Headquarters',
    declined:'Declined',cancelled:'Cancelled',invited:'Invitation sent',
    accepted:'Access active',revoked:'Access revoked'
  };
  let current = null;
  async function request(action,payload) {
    const db=window.AASupabaseClient?.getClient?.();
    const cfg=window.AA_SUPABASE_CONFIG;
    if(!db||!cfg?.url||!cfg?.anonKey)throw Error('Client Workspace connection unavailable.');
    const {data,error}=await db.auth.getSession();
    if(error||!data?.session?.access_token)throw Error('Sign in again to continue.');
    const response=await fetch(cfg.url+'/functions/v1/aa-client-team-service',{
      method:'POST',
      headers:{Authorization:'Bearer '+data.session.access_token,apikey:cfg.anonKey,'Content-Type':'application/json'},
      body:JSON.stringify({action,...payload})
    });
    const result=await response.json().catch(()=>({}));
    if(!response.ok||!result.success)throw Error(result.error||'Unable to process employee request.');
    return result.data;
  }
  function permissions(roleKey,selected){
    if(!current)return '';
    const role=current.roles.find(r=>r.role_key===roleKey);
    const keys=selected || current.defaults.filter(d=>d.role_id===role?.id).map(d=>d.permission_key);
    return current.permissions.filter(p=>p.scope==='client'&&!locked.has(p.permission_key)).map(p=>
      '<label class="aa-client-team__permission"><input type="checkbox" name="permission" value="'+escape(p.permission_key)+'" '+
      (keys.includes(p.permission_key)?'checked':'')+'><span>'+escape(p.description||p.permission_key)+'</span></label>'
    ).join('');
  }
  function draw(root,status='') {
    if(!current || !current.isClientOwner) {root.hidden=true;return;}
    root.hidden=false;
    const employees=(current.members||[]).filter(m=>m.active&&m.roleKey!=='client_owner');
    const requests=(current.requests||[]);
    root.innerHTML='<div class="aa-client-team">'+
      '<header class="aa-client-team__header"><h2>Team &amp; Access</h2><p>Need an employee to have access? Request it here. Artisan’s Avenue will approve their role and permissions before any invitation is sent.</p></header>'+
      '<p class="aa-client-team__feedback" role="status" data-aa-owner-team-status>'+escape(status)+'</p>'+
      '<section class="aa-client-team__section"><h4>Current employees</h4>'+
      (employees.length?employees.map(m=>'<div class="aa-client-team__person"><strong>'+escape(m.email)+
        '</strong><span>'+escape(roleNames[m.roleKey]||m.roleName)+'</span></div>').join(''):
        '<p class="aa-client-team__empty">No employees have access yet.</p>')+
      '</section>'+
      '<section class="aa-client-team__section"><h4>Request employee access</h4>'+
      '<form data-aa-owner-team-form class="aa-client-team__form">'+
      '<div class="aa-client-team__fields">'+
      '<label>Employee name<input name="employeeName" maxlength="120" required></label>'+
      '<label>Employee email<input name="employeeEmail" type="email" autocomplete="off" maxlength="254" required></label>'+
      '<label>Requested role<select name="employeeRole" data-aa-owner-role>'+
      '<option value="client_manager">Client Manager</option>'+
      '<option value="client_employee">Client Contributor</option></select></label></div>'+
      '<p class="aa-client-team__caption">Requested permissions</p>'+
      '<div class="aa-client-team__permissions" data-aa-owner-permissions>'+permissions('client_manager')+'</div>'+
      '<label class="aa-client-team__note">Optional note to Artisan’s Avenue<textarea name="note" maxlength="1000" rows="2"></textarea></label>'+
      '<button type="submit" class="aa-button aa-button--primary">Submit Employee Request</button>'+
      '</form></section>'+
      '<section class="aa-client-team__section"><h4>Employee requests</h4>'+
      (requests.length?requests.map(r=>
        '<div class="aa-client-team__request"><div><strong>'+escape(r.requested_name)+'</strong>'+
        '<p>'+escape(r.requested_email)+' · '+escape(roleNames[r.requested_role_key]||r.requested_role_key)+'</p>'+
        '<p class="aa-client-team__request-state">'+escape(labelStatus[r.status]||r.status)+'</p></div></div>'
      ).join(''):'<p class="aa-client-team__empty">No employee requests yet.</p>')+
      '</section></div>';
  }
  async function load(root,clientId,status=''){
    root.hidden=false;
    root.innerHTML='<p class="aa-client-team__loading">Loading employee access...</p>';
    try{
      const result=await request('overview',{clientId});
      if(!result.isClientOwner){root.hidden=true;return;}
      current=result;
      draw(root,status);
    }catch(e){
      root.innerHTML='<p role="alert">'+escape(e.message)+'</p>';
    }
  }
  function mount(workspace){
    const root=document.querySelector('[data-aa-owner-team]');
    if(!root || workspace?.isInternal || workspace?.role!=='client_owner' || !workspace?.clientId)return;
    root.dataset.aaOwnerClientId=workspace.clientId;
    load(root,workspace.clientId);
  }
  document.addEventListener('change',event=>{
    const selector=event.target.closest('[data-aa-owner-role]');
    if(!selector||!current)return;
    const p=selector.closest('[data-aa-owner-team]')?.querySelector('[data-aa-owner-permissions]');
    if(p)p.innerHTML=permissions(selector.value);
  });
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-aa-owner-team-form]');
    if(!form)return;
    event.preventDefault();
    const root=form.closest('[data-aa-owner-team]');
    const clientId=root?.dataset.aaOwnerClientId;
    if(!clientId)return;
    const button=form.querySelector('button[type="submit"]');
    const status=root.querySelector('[data-aa-owner-team-status]');
    button.disabled=true;
    if(status)status.textContent='Sending your request to Headquarters...';
    try{
      await request('create-request',{
        clientId,
        name:form.elements.employeeName.value.trim(),
        email:form.elements.employeeEmail.value.trim(),
        roleKey:form.elements.employeeRole.value,
        permissionKeys:[...form.querySelectorAll('[name="permission"]:checked')].map(p=>p.value),
        note:form.elements.note.value.trim()
      });
      await load(root,clientId,'Request submitted to Headquarters. No invitation has been sent.');
    }catch(e){
      if(status)status.textContent=e.message;
      if(button.isConnected)button.disabled=false;
    }
  });
  window.AAClientTeamOwner={mount};
})();
